import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { GraphQLClient } from './GraphQLClient';
import {
  WorkflowModes,
  WorkflowModesID,
} from 'src/products/data-submission-portal/__generated__/constants';
import { DSPHasuraJWT } from './jwt';

export const dspEnvironmentFactory =
  (role = 'default', mode?: WorkflowModesID) =>
  async () => {
    const jwtTokenClient = DSPHasuraJWT.getInstance();
    await jwtTokenClient.setMode(mode ?? WorkflowModes.PRODUCTION.id);

    const client = new GraphQLClient(
      jwtTokenClient.getBaseUrl(),
      role,
      async () => {
        await jwtTokenClient.queueFetchHasuraToken();
        return jwtTokenClient.getEncodedToken();
      }
    );

    const network = Network.create(
      client.fetchOrSubscribe(),
      client.fetchOrSubscribe()
    );

    return new Environment({
      network,
      store: new Store(new RecordSource()),
    });
  };
